import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { image } from "../../../Assets";
import { useLocation } from "react-router-dom";
import TeamModal from "../../../Component/TeamForm/TeamForm";
import BookCall from "../../../Component/BookCall/BookCall";

const Header = () => {
  const [openMenu, setopenMenu] = useState(false);
  const [serviceDropdown, setServiceDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState("bim");
  const [openModal, setOpenModal] = useState(false);

  const location = useLocation();
  const dropdownRef = useRef(null);
  const headerRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (location.pathname !== "/") {
      const header = document.querySelector("header");
      header && header.classList.add("greenheader");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        serviceDropdown &&
        dropdownRef.current &&
        headerRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !headerRef.current.contains(event.target)
      ) {
        setServiceDropdown(false);
      }

      if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") setOpenModal(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [serviceDropdown, openModal]);

  return (
    <>
      <header ref={headerRef}>
        {/* 🔹 YOUR HEADER CODE — UNCHANGED */}
        <div className="header-wrapper">
          <div className="container mainbar">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-5">
                <a href="/">
                  <img src={image.logo} alt="" id="logo" />
                </a>
              </div>

              <div className="col-lg-7 col-md-9 col-7 d-flex align-items-center justify-content-center">
                <div className="menu">
                  <ul className="tw-m-0">
                    <li className="page-link"><a href="/">Home</a></li>
                    <li className="page-link"><a href="/about">About</a></li>
                    <li className="page-link" onClick={() => setServiceDropdown(prev => !prev)}>
                      <span>Services</span>
                    </li>
                    {/* <li className="page-link"><a href="/">Resources</a></li> */}
                  </ul>
                </div>

                <div className="mobile-toggle" onClick={() => setopenMenu(!openMenu)}>
                  <svg width="76" height="48" viewBox="0 0 76 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0H48.1581C52.1093 0 55.69 2.32651 57.2954 5.93683L76 48H26.9672C22.9524 48 19.3268 45.5989 17.7601 41.9024L0 0Z" fill="#157438"/>
                  <rect x="24" y="13" width="27" height="2" rx="1" fill="white"/>
                  <rect x="38" y="23" width="13" height="2" rx="1" fill="white"/>
                  <rect x="31" y="33" width="20" height="2" rx="1" fill="white"/>
                  </svg>

                </div>
              </div>

              <div className="col-md-2 col-12 d-flex align-items-center justify-content-end">
                <div className="contact-btn">
                  <a href="/contact
                  ">Contact</a>
                </div>             
              </div>
            </div>
          </div>
        </div>
          {/* 🔹 SERVICES DROPDOWN — UNCHANGED */}
          <div ref={dropdownRef} className={`services-dropdown ${serviceDropdown ? "open" : ""}`}>
            <div className="services-top">
              <div className="tabs">
                <button className={activeTab === "bim" ? "active" : ""} onClick={() => setActiveTab("bim")}>BIM / VDC Services</button>
                <button className={activeTab === "engineering" ? "active" : ""} onClick={() => setActiveTab("engineering")}>Project Engineering Services</button>
              </div>

              <div className="tab-content">
                {activeTab === "bim" && (
                  <div className="row">
                    <div className="col-3">
                      <b className="tw-text-[#157438]">Industry</b>
                      <ul>
                        <li><a href="/visualisation/2D&3D-rendering">2D / 3D Rendering</a></li>
                        <li><a href="/visualisation/3D-Walkthrough-Flythrough">3D Walkthroughs</a></li>
                        <li><a href="/visualisation/4D-Simulations">4D Simulations</a></li>
                      </ul>
                    </div>

                    <div className="col-4">
                      <b className="tw-text-[#157438]">Modeling</b>
                      <ul>
                        <li><a href="/modeling/2D-to-3D-modeling">2D(CAD/PDF) to Supplemental 3D Modeling</a></li>
                        <li ><a href="/modeling/supplemental-modeling">Supplemental Modeling</a></li>
                        <li><a href="/modeling/point-cloud-to-3D-modeling">Point Cloud to 3D Modeling</a></li>
                      </ul>
                    </div>

                    <div className="col-3">
                      <b className="tw-text-[#157438]">BIM Management</b>
                      <ul>
                        <li><a href="/BIM-Management/clash-detection-and-coordination">Clash Detection and Coordination</a></li>
                        <li><a href="/BIM-Management/BIM-execution-planning">BIM Execution Planning</a></li>
                      </ul>
                    </div>
                  </div>
                )}

                {activeTab === "engineering" && (
                  <ul className="tab2">
                    <li><a href="/shop-drawing-creation">Shop Drawing Creation</a></li>
                    <li><a href="/2D-overlay">2D Overlay</a></li>
                    <li>
                      <a href="/RFI-order-date-in-PM-software">
                        Document Management for RFIs, Submittals & Change Orders
                      </a>
                    </li>
                  </ul>
                )}
              </div>
            </div>

            <div className="services-wrapper-footer">
              <div className="services-bottom">
                <h2>Lets get working</h2>
                <div className="row align-items-center">
                  <div className="col-8">
                    <p>
                      At Fractile, you’ll work on impactful projects, learn from seasoned leaders, and grow your technical craft.
                      If you’re committed to excellence, we’re committed to you.
                    </p>
                  </div>
                  <div className="col-4 d-flex tw-justify-end">
                    <button className="btn-2-white" onClick={() => setOpenModal(true)}>Discuss Your Project</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </header>

      {/* 🔹 MOBILE MENU — UNCHANGED */}
      <div className="mobilemenu" style={{ left: openMenu ? "0%" : "-100%" }}>
        <div className="tw-w-36 logo-mobile">
          <img src={image.logo} alt="" />
        </div>
        <div className="mobile-close" onClick={() => setopenMenu(false)}>
          <svg width="76" height="48" viewBox="0 0 76 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H48.1581C52.1093 0 55.69 2.32651 57.2954 5.93683L76 48H26.9672C22.9524 48 19.3268 45.5989 17.7601 41.9024L0 0Z" fill="#157438"/>
            <rect
              x="37"
              y="15"
              width="2"
              height="18"
              rx="1"
              fill="white"
              transform="rotate(45 38 24)"
            />
            <rect
              x="37"
              y="15"
              width="2"
              height="18"
              rx="1"
              fill="white"
              transform="rotate(135 38 24)"
            />
          </svg>
        </div>
        <ul>
          <li className="page-link"><a href="/" onClick={() => setopenMenu(false)}>Home</a></li>
          <li className="page-link"><a href="/about" onClick={() => setopenMenu(false)}>About</a></li>
          <li className="page-link">Services &#9660; </li>
          <li className="tw-text-[#157438]">Industry</li>
              <ul>
                <li><a href="/visualisation/2D&3D-rendering">2D / 3D Rendering</a></li>
                <li><a href="/visualisation/3D-Walkthrough-Flythrough">3D Walkthroughs</a></li>
                <li><a href="/visualisation/4D-Simulations">4D Simulations</a></li>
              </ul>  
          <li className="tw-text-[#157438]">Modeling</li>
          <ul>                              
            <li><a href="/modeling/2D-to-3D-modeling">2D(CAD/PDF) to Supplemental 3D Modeling</a></li>
            <li><a href="/modeling/supplemental-modeling">Supplemental Modeling</a></li>          
            <li><a href="/modeling/point-cloud-to-3D-modeling">Point Cloud to 3D Modeling</a></li>
          </ul>
          <li className="tw-text-[#157438]">BIM Management</li>
          <ul>
            <li><a href="/BIM-Management/clash-detection-and-coordination">Clash Detection and Coordination</a></li>
            <li><a href="/BIM-Management/BIM-execution-planning">BIM Execution Planning</a></li>           
          </ul>
           {/* <li className="page-link"><a href="/" onClick={() => setopenMenu(false)}>Resources</a></li> */}
        </ul>
      </div>

      
      <BookCall isOpen={openModal} onClose={() => setOpenModal(false)}/>        
      
    </>
  );
};

export default Header;
